<template>
<div class="all" id="5">
 <img  class="image" src="../../public/assets/img/avion.png" />
 <p class="titre is-size-1 is-hidden-mobile" style="margin-left:2%;"> Contactez-nous </p>
 <p class="titre  is-size-5 is-hidden-desktop" style="margin-top:15%;  display: block;margin-left: auto; margin-right: auto ;"> Contactez-nous </p>

   <form @submit.prevent="sendEmail">
    <div class="columns" >
        <div class="column" style="visibility:hidden;">
          First
        </div>
      <div class="column is-one-fifth">
        <div class="field">
            <label class="label is-hidden-touch is-medium">Prénom</label>
            <label class="label is-hidden-desktop is-normal">Prénom</label>
        <div class="control">
            <input class="input  is-rounded" style="height:6vh;"
              type="text" 
              v-model="name"
              name="name"
              placeholder="Ex. Alex"
            >
         
        </div>
        </div>
        
        <div class="field">
          <label class="label is-hidden-touch is-medium">Nom de famille</label>
          <label class="label is-hidden-desktop is-normal">Nom de famille</label>
        <div class="control">     
            <input  class="input  is-rounded" style="height:6vh;"
              type="text" 
              v-model="name2"
              name="name2"
              placeholder="Ex. Smith"
            >
        </div>
        </div> 
      </div>
      <div class="column is-one-fifth">
     <div class="field">   
            <label class="label is-hidden-touch is-medium">Email</label>
            <label class="label is-hidden-desktop is-normal">Email</label>
        <div class="control">
            <input  class="input is-rounded" style="height:6vh;"
              type="email" 
              v-model="email"
              name="email"
              placeholder="Ex. alexsmith@gmail.com"
              >
        
        </div>
        </div>
        <div class="field">
          <label class="label is-hidden-touch is-medium">Téléphone</label>
          <label class="label is-hidden-desktop is-normal">Téléphone</label>
        <div class="control">

          <input class="input  is-rounded" style="height:6vh;" 
            type="text" 
            v-model="number"
            name="tel"
            placeholder="Ex. 06.xx.xx.xx.xx"
          >
          
    
        </div>
        </div>
      </div>      
      <div class="column is-hidden-touch" style="visibility:hidden;">
        Last
      </div>
    </div>
    <div class="columns" >
      <div class="column is-hidden-touch" style="visibility:hidden;">
        First
      </div>  
    
    <div class="column is-two-fifths" >
      <div class="field" style="width:93%; ">
        <label class="label is-hidden-touch is-medium">Message</label>
        <label class="label is-hidden-desktop is-normal">Message</label>
        
        <textarea  class="textarea" style="height:6vh;"
          name="message"
          v-model="message"
         
          placeholder="Message">
        </textarea>


      </div>
      <div class="control">  
            <button   type="submit" value="Send" class="button  is-hidden-touch is-rounded is-large" style="margin-bottom:12%;">Envoyer</button>
            <button    type="submit" value="Send"  class="button  is-hidden-desktop is-rounded is-normal">Envoyer</button>
      </div>
    </div>
    <div class="column" style="visibility:hidden; margin-top:10%;">
      Last
    </div>
    </div>
        </form> 
 <Foot/>
</div>

</template>

<script>

import Foot from './Foot.vue';
import emailjs from 'emailjs-com';

export default {
  name: "ContactPage",
  data() {
    return {
      name: '',
      name2: '',
      email: '',
      message: '',
      tel:' ',
 
    }
  },
   components: {
    Foot,
    
  },
  methods: {
    sendEmail(e) {
      try {
        emailjs.sendForm('service_7bitaz2', 'template_p6fp0jf', e.target,
        'user_smI77n78M3EFXG060cry3', {
          name: this.name,
          name2: this.name2,
          email: this.email,
          message: this.message,
          tel: this.tel,
        
        })

      } catch(error) {
          console.log('FAILED...', error);
      }
      // Reset form field
      this.name = ''
      this.name2 = ''
      this.email = ''
      this.message = ''
      this.tel = ''
    },
  }
};
 
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Spartan:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300&display=swap');

.all{
  background-color: #FCFCFC;
}
.image{
 padding-top:5%;
 margin-top:5%;
 margin-left:62%;
 width:7%;
}
.titre{
 margin-top:-5%;
 color:#482A5C;
 margin-right:20%;
 font-family: 'Spartan', sans-serif;
 font-weight: bold;
}

.button{
  background-color: #482A5C;
  float:right;
  margin-right:5%;
  margin-top: 5%;
  color:white;
  width:auto;
  font-family: 'Montserrat', sans-serif;
}
.textarea{
  background-color:#C9C1CF;
  border-radius: 28px;
}

.label{
  text-align: left;
  font-family: 'Montserrat', sans-serif;
}

.field{
  width:85%;
  margin-left:3%;
  margin-top: 3%;
}
.input{
  background-color:#C9C1CF;
  color:black;


}
</style>
